<template>
  <PageHeader />
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import PageHeader from '@/components/page-header.vue'
</script>
